<script lang="ts">
    import type { Snippet } from "svelte";
    import type { Booking } from "../model/Booking";
    import { Game } from "../model/Game";
    import { AuthInfo, getAuthInfo } from "./AccountUtility";

    let {
        desiredCompany,
        children,
        game,
        booking
    }: {
        desiredCompany?: string,
        game?: Game,
        booking?: Booking,
        children: Snippet
    } = $props();

    let auth: AuthInfo = getAuthInfo();

    let hasAuth: boolean = $derived.by((): boolean => {
        if(game) {
            if(game.developer == auth.getCompanyId() || game.publisher == auth.getCompanyId()) {
                return true;
            }
        }
        if(booking) {
            if(booking.advertiser == auth.getCompanyId()) {
                return true;
            }
        }

        if(desiredCompany && desiredCompany == auth.getCompanyId()) {
            return true;
        }

        if(auth.isAdmin()) {
            console.log("Granting access as admin");
            return true;
        }
        return false;
    });
</script>

{#if hasAuth}
    {@render children()}
{/if}